import React from "react";

const About = () => {
  return (
    <section id="about">
      <h2>About Infobizz</h2>

      <p>
        Infobizz is a professional IT services company focused on delivering
        high-quality digital products and technology solutions. Our mission is
        to help businesses transform their ideas into powerful digital
        experiences.
      </p>

      <p>
        With a skilled team of developers, designers, and technology experts, we
        provide end-to-end services from concept, design, development, testing,
        and deployment to long-term support.
      </p>

      <p>
        We believe in innovation, transparency, and long-term partnerships with
        our clients.
      </p>
    </section>
  );
};

export default About;
